var _style, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _defs, _mask, _g, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _defs2, _path69, _g2, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWaitingGraphic(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 440 332",
    style: {
      enableBackground: "new 0 0 440 332"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#F8F9FD;}\n\t.st1{fill:url(#SVGID_1_);}\n\t.st2{fill:#BCC1C6;}\n\t.st3{fill:#FFFFFF;}\n\t.st4{fill:#69A1AC;}\n\t.st5{fill:#007BCC;}\n\t.st6{fill:#9ECAFF;}\n\t.st7{fill:#E4E6EB;}\n\t.st8{fill:#D9D9D9;}\n\t.st9{fill:#89C5CC;}\n\t.st10{fill:#49454F;}\n\t.st11{fill:none;stroke:#D4D4D4;stroke-width:1.875;}\n\t.st12{fill:none;stroke:#FFFFFF;stroke-width:0.625;stroke-linecap:round;stroke-linejoin:round;}\n\t.st13{fill:#C5CFD6;}\n\t.st14{fill:#A1ADB6;}\n\t.st15{fill:#83949E;}\n\t.st16{fill:#ACB8C0;}\n\t.st17{fill:#383E77;}\n\t.st18{fill:#5C63AB;}\n\t.st19{fill:none;stroke:#323669;stroke-width:0.625;}\n\t.st20{fill:#8B8DC2;}\n\t.st21{fill:#8A90A5;}\n\t.st22{fill:#575E71;}\n\t.st23{fill:#010326;}\n\t.st24{fill:#FFC0A1;}\n\t.st25{fill:#F4A179;}\n\t.st26{fill:#FFC0A0;}\n\t.st27{fill:#010325;}\n\t.st28{fill:#383E77;fill-opacity:0.6;}\n\t.st29{filter:url(#Adobe_OpacityMaskFilter);}\n\t.st30{mask:url(#mask0_570_46672_00000075154526431637749340000017808226203804444806_);}\n\t.st31{fill:#C5DCFB;}\n\t.st32{fill:#DFECFF;}\n\t.st33{fill:none;stroke:#010326;stroke-width:0.5625;}\n\t.st34{fill:#4429A6;}\n\t.st35{fill:none;stroke:#000000;stroke-width:0.6562;stroke-miterlimit:10;}\n\t.st36{fill:#E20074;filter:url(#Adobe_OpacityMaskFilter_00000093876541957515250880000006867244160678852785_);}\n\t.st37{fill:#E20074;}\n\t.st38{mask:url(#mask1_570_46672_00000046336222066515831720000016897988064436964783_);}\n\t.st39{fill:#F5D9DE;}\n\t.st40{fill:#2F3677;}\n\t.st41{fill:#5C67B2;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M331.2,279.4c101.9-17.7,107-67.9,81.2-112.7c-32.2-55.8-2-94.4-43.3-102.9c-42.9-8.9-43.4,99.5-142.1,98.3 C81.2,160.3,202.8,301.7,331.2,279.4z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 344.6125,
    y1: 352.6336,
    x2: 117.5335,
    y2: 91.6127,
    gradientTransform: "matrix(1 0 0 -1 0 334)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F8F9FD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    style: {
      stopColor: "#ECEFF5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    style: {
      stopColor: "#E1E6ED"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    style: {
      stopColor: "#E2E5EC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E3E5EA"
    }
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M56.7,29.1c0-8.1,6.5-14.6,14.6-14.6h289.5c8.1,0,14.6,6.5,14.6,14.6v200c0,8.1-6.5,14.6-14.6,14.6H71.3 c-8.1,0-14.6-6.5-14.6-14.6V29.1z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M91.6,162.9c0-4.5,3.6-8.1,8.1-8.1h185.6c4.5,0,8.1,3.6,8.1,8.1v117.6c0,4.5-3.6,8.1-8.1,8.1H99.7 c-4.5,0-8.1-3.6-8.1-8.1V162.9z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M290.4,253.4H125.1c-4.7,0-8.6-3.8-8.6-8.6V82.9c0-4.7,3.8-8.6,8.6-8.6h165.3c4.7,0,8.6,3.8,8.6,8.6v161.9 C298.9,249.5,295.1,253.4,290.4,253.4z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M285.8,10l10.5-8.9l7.1,8.3l-10.5,8.9L285.8,10z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M156,13.3l10.5-8.9l7.1,8.3l-10.5,8.9L156,13.3z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M148.7,311.1l10.5-8.9l7.1,8.3l-10.5,8.9L148.7,311.1z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M16.6,85.3L27,76.4l7.1,8.3l-10.5,8.9L16.6,85.3z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M236.9,251.7l3.5-9.5l7.6,2.8l-3.5,9.5L236.9,251.7z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M36.2,192.6l10.1,1.1l-0.9,8l-10.1-1.1L36.2,192.6z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M189.3,82.2l3.6-9.8l7.8,2.9l-3.6,9.8L189.3,82.2z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M392,139.6l10.1,1.1l-0.9,8l-10.1-1.1L392,139.6z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M339.9,90.7l15.8-8.4l7,13l-15.8,8.4L339.9,90.7z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M346.4,140c5-10.6,17.7-15.1,28.3-10.1c10.6,5,15.1,17.7,10.1,28.3c-4.6,9.6-15.4,14.2-25.3,11.2l-5.9,4 l-0.6-7.2C345,160.4,341.9,149.4,346.4,140z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M364.6,158.8l-8.3-6l2.9-3.9l4.5,3.3l8.9-11.4l3.8,3L364.6,158.8z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M39,317.6h291.2H39z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M161,206.7c0,0,24.4-52.8,13.6-54.7c-7.7-1.3-13.7,8.1-13.7,8.1s5.2-34.9-7.1-36.1 c-11.4-1.2-16.1,15.7-16.1,15.7s-20.2-22.4-32.3-16.6c-12.2,5.8-1.2,25.9-1.2,25.9s-19-5.2-22.4,4c-6.9,18.9,19.2,26.6,19.2,26.6 s-21.5-3.5-22.4,3.5c-0.9,7.1,23.8,32.2,56.4,29.1C167.7,209,161,206.7,161,206.7z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M111.2,129.6c0,0,19.2,26.1,37.6,71.6"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M151.7,132.2c0,0-2,22.2-16.8,38.3"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M88.3,157.8c0,0,14.4,11.6,46.6,13.6"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M171.4,158.4c0,0-6.9,21.7-26.3,34.2"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M88.1,186c0,0,13.9,13.7,57.4,7.5"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M270.4,253.5c0,0-29.9-5.4-19.5-40c6.5-21.6,17.9-36.6,11.7-59.4c-4.8-17.6,4.3-27.9,19.3-27.8 c15,0.1,22.5,15.9,17.7,31.8c-9.6,31.7,4.7,36.4,3.6,60.7C301.4,258.4,270.4,253.5,270.4,253.5z"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M282.5,131.7c0,0-0.2,100.2-6.8,120.8"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M282.3,160c0,0,10.2-6.5,14.4-11.2"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M281.6,186.8c0,0,8.7-4.7,12.8-9.3"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M280.3,213.6c0,0,8.7-4.7,12.8-9.3"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M282.3,160c0,0-10.1-6.7-14.2-11.4"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M281.6,186.7c0,0-11.7-6.2-15.7-10.9"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M280.3,213.6c0,0-15.3-5.3-20.8-16.2"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M288,257.9c0,0-13.8-12.3-7.2-26.2c7.5-15.8,22.7-14.8,24.3-36.9c0.8-11.1,21.2-19.2,27.1-16.7 c5.9,2.5,11.1,19.5-0.3,28.8c-16.4,13.4-8.8,27.5-16.8,39C307,257.4,288,257.9,288,257.9z"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M330,182.6c0,0-19,13.3-43.1,75.2"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M315.1,201c0,0,8.9,2.3,20.1-1.3"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M314.7,201.1c0,0-4.8-4-4.6-10.1"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M298,215.8c0,0-0.6,5.6,3.1,8.8c0,0,10.1,2.3,15.8,0.6"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M283.7,232.9c0,0,0,11.5,7.5,14.5c0.5,0.2,9.6,2.3,19.6-0.5"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M248.8,316.7h37.7l24-63.5h-70.4L248.8,316.7z"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M181,318.8h55.8c17.1,0,46.1-13.6,46.1-37.2c0-23.5,29.3-21.7,6.6-67.2c-18.6-37.4-42.6-35-85.7-34.8 c-45.1,0.2-74.4,16.5-77.5,45.1c-3.1,28.7-42.3,45.1-22.9,66.3C122.8,312.2,73.9,318.8,181,318.8z"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M193.8,275.6c9.3-0.3,18.8-0.6,27.9-3c7.2-1.9,13.8-5.1,19.5-9.5c11.3-8.7,18.6-21.3,19.7-34.8 c0.1-0.9-1.5-0.9-1.5,0c-1.1,13.1-8.4,25.4-19.3,33.8c-5.7,4.4-12.5,7.6-19.7,9.4c-8.7,2.1-17.7,2.4-26.6,2.7 C192.8,274.2,192.8,275.6,193.8,275.6z"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M286.4,256.3c-5.1,1.5-8.5,5.3-10.5,9.7c-1.2,2.8-1.9,5.7-2.4,8.6c-0.6,3.3-1.7,7.9-6.4,7.6 c-1-0.1-1,1.4,0,1.4c6.2,0.4,7.3-6.1,8.1-10.3c1.3-6.4,4.1-13.6,11.5-15.7C287.8,257.4,287.4,256.1,286.4,256.3z"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M167.7,239.8c0,0-17.6,38.3-17.1,74.1c6.6,1.9,22.9-54.8,26-54.1c17.3,4.2,64.2,4.7,66-20 c1.1-15.1,9.2-23,9.2-30.1s7.1-12.2-7.6-16.9c-14.8-4.7-15.8-7.1-32.1-1.4C195.8,197,163.6,230.9,167.7,239.8z"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M144.5,241.4c0,0-31.6,37.3-32.2,40.7c6.6,1.9,44.4-19.8,47.2-21.2c5.1-2.6,17.6-12.1,44.4-10.6 c8.4,0.5,7.1-29.9,7.1-36.9c0-7.1,47.9-16,33.1-20.7c-14.8-4.7-15.8-7.1-32.1-1.4C195.8,197,152.4,235.8,144.5,241.4z"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M172.2,236.5c0,0-21.4-5.2-29.1,4.2c-5.6,6.9,3.6,76.2,5.6,78.1c2,1.9,18.9-62.1,18.9-62.1l42.8-4.7 L172.2,236.5z"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M175.5,236.5c0,0-21.4-5.2-29.1,4.2c-5.1,6.3,4.3,76.8,4.3,76.8c0.3,1,1.1,1.1,1.3,1.3 c2,1.9,18.9-62.1,18.9-62.1l42.8-4.7L175.5,236.5z"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M237.6,205.9c0,0,15.8,24.9-0.5,43.3c-7,7.9-19.5,7.2-33.7,5.6c-37.7-4.2-53.5-18.8-53.5-18.8l-54.2,28.1 c-1.2,0.8-6.4-1-5.7-2.3c8.3-14,40.9-47.9,51.8-52.2c13.3-5.2,43.3,13.2,55.1,12.7c-8.7-5.6-4.6-9.9-4.1-11.8 C193.2,208.8,237.6,205.9,237.6,205.9z"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M93.5,272.8c0,0,3.9-5.7,4.7-7.1c-1.3-0.3-3.2-1.1-4-2.7c-0.5-1-4.9-2-6.6-2.4c-3.2-0.7-7.9-1.2-12.5-1.1 c-4.9,0.1-6.2,3-6.2,3S76.1,266.3,93.5,272.8z M93.6,272.6l-24.6-10l-0.4,0.9l24.3,10.3L93.6,272.6z"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M93.5,272.8c0,0,3.9-5.7,4.7-7.1c-1.3-0.3-3.2-1.1-4-2.7c-0.5-1-4.9-2-6.6-2.4c-3.2-0.7-7.9-1.2-12.5-1.1 c-4.9,0.1-6.2,3-6.2,3S76.1,266.3,93.5,272.8z M93.6,272.6l-24.6-10l-0.4,0.9l24.3,10.3L93.6,272.6z"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M93.6,272.6l-24.6-10l-0.4,0.9l24.3,10.3L93.6,272.6z"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M236.6,226.6l11.7-12.2v-1.6l-19,1.6l-29.5,2.4L236.6,226.6z"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M235.9,225.5l12.4-12.7h-19l-29.5,2.4L235.9,225.5z"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    className: "st21",
    d: "M186.9,176.8c-5.8,8.5-12.6,25.4-12.2,26.5c0.4,1.1,1.6,14.8,7.6,14.1c6-0.7,29.8,3.8,38.2,3.8 c8.4,0,11.7-0.5,11.7-0.5s17.9-16.1,20.4-29.4c3.8-20-19.6-22.3-25.8-22.9c-6.9-0.7-14.2-0.8-14.2-0.8S195.8,163.8,186.9,176.8z"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M188.9,192.7h2.8l3-12.2L188.9,192.7z"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    className: "st23",
    d: "M206.8,142.9c0,0-6.5-11.7-8.7-5.6c-1.9,5.3-0.4,18.8-0.4,18.8l3.6,12l8.3-5L206.8,142.9z"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M242.2,183.4c0,0-3.1,10.6-5.3,13.5c-5.2,6.9-11.2,9.6-12.9,10.1c-8.8,2.4-24.7-0.9-26.2,0.5 c-3.2,2.9,4.8,2.7,4.8,2.7l9.4-0.5c17.8,0,16.9-0.5,22.9-8.5C241.1,193.2,242.2,183.4,242.2,183.4z"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    className: "st24",
    d: "M221,156.7c0,0-3.6-0.1-7.8,3.4c0.9,7.9-1,7.8-1,7.8s-3.6,0.7-4,2c-0.8,3.1-0.3,6.5,1.9,10.8 c8.8-2.6,20.8-11.9,14.4-13.1C224.1,164.5,221,156.7,221,156.7z"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    className: "st24",
    d: "M221,156.7c0,0-3.6-0.1-7.8,3.4c0.9,7.9-1,7.8-1,7.8s-3.6,0.7-4,2c-0.8,3.1-0.3,6.5,1.9,10.8 c8.8-2.6,20.8-11.9,14.4-13.1C224.1,164.5,221,156.7,221,156.7z"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    className: "st25",
    d: "M221,156.7c0,0-3.6-0.1-7.8,3.4c0.9,7.9-1,7.6-1,7.6s9.2-0.2,10.7-4.4C224,160.5,221,156.7,221,156.7z"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    className: "st25",
    d: "M221,156.7c0,0-3.6-0.1-7.8,3.4c0.9,7.9-1,7.6-1,7.6s9.2-0.2,10.7-4.4C224,160.5,221,156.7,221,156.7z"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    className: "st26",
    d: "M232.1,143.7c0,12.2-14.9,21-19.4,21c-4.5,0-12.4-9.2-12.4-18.7s7.2-17.2,16.1-17.2 C225.3,128.9,232.1,134.3,232.1,143.7z"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    className: "st27",
    d: "M200,148c0,0,13,0.6,21.7-1.6c0.4,2.1,0.5,2,0.6,7.1c0,5.9-1.2,15.7-1.2,15.7s9.4-4.1,12.6-9 c2.3-3.4,1.6-21.5-0.5-26c-3.7-8-10.5-10.1-17.6-10.1s-17.8,4.8-18.4,15.1C196.7,146.1,200,148,200,148z"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    className: "st28",
    d: "M235.1,227.7c0,0-17.3,13.4-27.7,9.9c-57.1-19.4-71.3-10.7-68.2-17.8c3.1-7.1,21.9-8.3,21.9-8.3 S206.8,228.6,235.1,227.7z"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter",
    filterUnits: "userSpaceOnUse",
    x: 146.9,
    y: 192.1,
    width: 88,
    height: 35.6
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 1 0"
  })))), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 146.9,
    y: 192.1,
    width: 88,
    height: 35.6,
    id: "mask0_570_46672_00000075154526431637749340000017808226203804444806_"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M235.1,226.9c0,0-17.3,13.4-27.7,9.9c-57.1-19.4-71.3-10.7-68.2-17.8c3.1-7.1,21.9-8.3,21.9-8.3 S206.8,227.9,235.1,226.9z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "st30"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st31",
    d: "M168.4,218.9L146.9,193l1.6-0.9H215l20,33.8l-1.6,1.1l-64-7.5L168.4,218.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st32",
    d: "M166.9,220.7L147,193.9h66.4l19.9,33.8l-64.2-6.7L166.9,220.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M194.2,211.1c0.5,2.3-1.2,4.2-3.7,4.2s-4.9-1.9-5.4-4.2c-0.5-2.3,1.2-4.2,3.7-4.2S193.7,208.8,194.2,211.1z"
  }))), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    className: "st33",
    d: "M155.1,320.2c0,0,0.7-3.5,0.7-5c0.1-2-0.2-3.9-0.9-5.2c-0.5-0.4-2.2,2.2-5.8-0.2c-1.5,0-5.9,1.1-7.2,1.4 c-6,1.5-8.2,3.4-9.6,3.8c-2.9,1-3.6,4.7-3.6,4.7S144.1,320,155.1,320.2z M155.3,319.1l-9,0l-17.4-0.1l0,1.5l26.5,0.4L155.3,319.1z"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M155.1,320.2c0,0,0.7-3.5,0.7-5c0.1-2-0.2-3.9-0.9-5.2c-0.5-0.4-2.2,2.2-5.8-0.2c-1.5,0-5.9,1.1-7.2,1.4 c-6,1.5-8.2,3.4-9.6,3.8c-2.9,1-3.6,4.7-3.6,4.7S144.1,320,155.1,320.2z M155.3,319.1l-9,0l-17.4-0.1l0,1.5l26.5,0.4L155.3,319.1z"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    className: "st23",
    d: "M155.3,319.1l-9,0l-17.4-0.1l0,1.5l26.5,0.4L155.3,319.1z"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    className: "st34",
    d: "M207.8,155.3c0.5,2.4-1.2,4.4-3.8,4.4c-2.6,0-5.2-2-5.7-4.4s1.2-4.4,3.8-4.4S207.3,152.9,207.8,155.3z"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    className: "st34",
    d: "M219.4,155.3c0.5,2.4-1.2,4.4-3.8,4.4c-2.6,0-5.2-2-5.7-4.4c-0.5-2.4,1.2-4.4,3.8-4.4 C216.4,150.9,218.9,152.9,219.4,155.3z"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    className: "st35",
    d: "M219.5,155.3l12.3-7.4"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    className: "st35",
    d: "M207.9,155.6h2.7"
  })), _defs2 || (_defs2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter_00000094585514129271995260000004400952177554356387_",
    filterUnits: "userSpaceOnUse",
    x: 172.9,
    y: 141.5,
    width: 31.7,
    height: 30.8
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 1 0"
  })))), /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 172.9,
    y: 141.5,
    width: 31.7,
    height: 30.8,
    id: "mask1_570_46672_00000046336222066515831720000016897988064436964783_"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E20074",
      filter: "url(#Adobe_OpacityMaskFilter_00000094585514129271995260000004400952177554356387_)"
    },
    d: " M207.6,155.3c0.5,2.3-1.2,4.2-3.6,4.2s-4.9-1.9-5.4-4.2c-0.5-2.3,1.2-4.2,3.6-4.2C204.7,151.2,207.1,153,207.6,155.3z"
  }), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    className: "st37",
    d: "M219.2,155.4c0.5,2.3-1.2,4.2-3.6,4.2c-2.5,0-4.9-1.9-5.4-4.2c-0.5-2.3,1.2-4.2,3.6-4.2 C216.3,151.2,218.7,153.1,219.2,155.4z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    className: "st38"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st39",
    d: "M182.1,141.5l22.5,30.8h-9.2l-22.5-30.8H182.1z"
  }))), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    className: "st40",
    d: "M65.8,263.4l29.9,12.2c0.4-0.3,0.8-0.8,1.1-1.4c1.3-2.3,2.3-6.3,3-8.8c0.1-0.3,0.2-0.6,0.2-0.8 c0.1-0.4,0.3-0.8,0.4-1c0.9-1.9-0.1-1.7-0.1-1.7c-4.3,1.5-6.7-4.6-9.4-4.1c0,0-1.1,0.2-4.5,1.2c-3.3,1-8,0.6-12,0.6 c-5.3-0.1-7.3,1.1-8.1,2.2C65.6,262.6,65.8,263.4,65.8,263.4z"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    className: "st41",
    d: "M65.8,263.4l29.9,12.2c0.4-0.3,0.8-0.8,1.1-1.4l-30.5-12.5C65.6,262.6,65.8,263.4,65.8,263.4z"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    className: "st41",
    d: "M92.6,274.3l0.9,0.4c-0.4-1.3-0.6-3.1,0.5-5.1c1.4-2.7,4.1-3.8,5.8-4.2c0.1-0.3,0.2-0.6,0.2-0.8 c-1.8,0.4-5,1.5-6.7,4.7C92.2,271.2,92.2,273,92.6,274.3z"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M86.2,260.8c0.2,0.1,0.5,0,0.6-0.2c0.2-0.2,0.1-0.5-0.1-0.7l-1.7-1.2c-0.2-0.2-0.6-0.1-0.8,0.1 c-0.2,0.2-0.1,0.5,0.1,0.7l1.7,1.2C86.1,260.8,86.1,260.8,86.2,260.8z"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M88.7,260.1c0.2,0.1,0.5,0,0.6-0.1c0.2-0.2,0.1-0.5-0.1-0.7l-1.7-1.2c-0.2-0.2-0.6-0.1-0.8,0.1 c-0.2,0.2-0.1,0.5,0.1,0.7l1.7,1.2C88.6,260.1,88.7,260.1,88.7,260.1z"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M83.8,261.1c0.2,0.1,0.5,0,0.6-0.1c0.2-0.2,0.1-0.5-0.1-0.7l-1.7-1.2c-0.2-0.2-0.6-0.1-0.8,0.1 c-0.2,0.2-0.1,0.5,0.1,0.7l1.7,1.2C83.8,261,83.8,261,83.8,261.1z"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M81.5,261.3c0.2,0.1,0.5,0,0.6-0.1c0.2-0.2,0.1-0.5-0.1-0.7l-1.7-1.2c-0.2-0.2-0.6-0.1-0.8,0.1 c-0.2,0.2-0.1,0.5,0.1,0.7l1.7,1.2C81.4,261.2,81.4,261.2,81.5,261.3z"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M79,261.3c0.2,0.1,0.5,0,0.6-0.2c0.2-0.2,0.1-0.5-0.1-0.7l-1.7-1.2c-0.2-0.2-0.6-0.1-0.8,0.1 c-0.2,0.2-0.1,0.5,0.1,0.7l1.7,1.2C78.9,261.3,79,261.3,79,261.3z"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M76.5,261.2c0.2,0.1,0.5,0,0.6-0.1c0.2-0.2,0.1-0.5-0.1-0.7l-1.7-1.2c-0.2-0.2-0.6-0.1-0.8,0.1 c-0.2,0.2-0.1,0.5,0.1,0.7l1.7,1.2C76.4,261.1,76.4,261.2,76.5,261.2z"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    className: "st40",
    d: "M124.3,321.3l32.7,0.6c0.3-0.4,0.4-1,0.5-1.7c0.3-2.5-0.5-6.6-0.9-9.2c0-0.3-0.1-0.6-0.1-0.8 c-0.1-0.4-0.1-0.8-0.1-1.1c0-2.1-0.8-1.5-0.8-1.5c-3.4,2.9-8.2-1.8-10.4-0.4c0,0-1,0.6-3.6,2.7c-2.6,2.1-7.1,3.5-10.9,4.8 c-4.9,1.8-6.3,3.6-6.6,4.9C123.8,320.6,124.3,321.3,124.3,321.3z"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    className: "st41",
    d: "M124.3,321.3l32.7,0.6c0.3-0.4,0.4-1,0.5-1.7l-33.4-0.6C123.8,320.6,124.3,321.3,124.3,321.3z"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    className: "st41",
    d: "M153.6,321.8l1,0c-1-1-1.8-2.6-1.7-4.9c0.2-3,2.2-5,3.6-6c0-0.3-0.1-0.6-0.1-0.8c-1.5,1-4,3.2-4.2,6.8 C152,319,152.7,320.6,153.6,321.8z"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M142,311.6c0.2,0,0.5-0.1,0.5-0.4c0.1-0.3-0.1-0.5-0.4-0.6l-2-0.5c-0.3-0.1-0.6,0.1-0.7,0.4 c-0.1,0.3,0.1,0.5,0.4,0.6l2,0.5C141.9,311.6,141.9,311.6,142,311.6z"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M144.1,310.1c0.2,0,0.5-0.1,0.5-0.4c0.1-0.3-0.1-0.5-0.4-0.6l-2-0.5c-0.3-0.1-0.6,0.1-0.7,0.4 c-0.1,0.3,0.1,0.5,0.4,0.6l2,0.5C144,310.1,144,310.1,144.1,310.1z"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M140,312.7c0.2,0,0.5-0.1,0.5-0.4c0.1-0.3-0.1-0.5-0.4-0.6l-2-0.5c-0.3-0.1-0.6,0.1-0.7,0.4s0.1,0.5,0.4,0.6 l2,0.5C139.9,312.7,139.9,312.7,140,312.7z"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M137.9,313.7c0.2,0,0.5-0.1,0.5-0.4c0.1-0.3-0.1-0.5-0.4-0.6l-2-0.5c-0.3-0.1-0.6,0.1-0.7,0.4 c-0.1,0.3,0.1,0.5,0.4,0.6l2,0.5C137.8,313.7,137.8,313.7,137.9,313.7z"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M135.6,314.6c0.2,0,0.5-0.1,0.5-0.4c0.1-0.3-0.1-0.5-0.4-0.6l-2-0.5c-0.3-0.1-0.6,0.1-0.7,0.4 c-0.1,0.3,0.1,0.5,0.4,0.6l2,0.5C135.5,314.6,135.6,314.6,135.6,314.6z"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M133.2,315.4c0.2,0,0.5-0.1,0.5-0.4c0.1-0.3-0.1-0.5-0.4-0.6l-2-0.5c-0.3-0.1-0.6,0.1-0.7,0.4 c-0.1,0.3,0.1,0.5,0.4,0.6l2,0.5C133.1,315.4,133.2,315.4,133.2,315.4z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWaitingGraphic);
export default __webpack_public_path__ + "static/media/WaitingGraphic.09af4742321b9676a525666eccef0549.svg";
export { ForwardRef as ReactComponent };